import { render, staticRenderFns } from "./ThumbUpIcon.vue?vue&type=template&id=70cc7f16&"
import script from "./ThumbUpIcon.vue?vue&type=script&lang=ts&"
export * from "./ThumbUpIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports